export enum AuditInforFormFields {
  CreatedById = 'createdById',
  CreatedTimestamp = 'createdTimestamp',
  UpdateById = 'updateById',
  UpdatedTimestamp = 'updatedTimestamp',
  CreateByPgmId = 'createByPgmId',
  UpdateByPgmId = 'updateByPgmId'
}
